import apiServiceCall from "../services/ApiServiceCall";

export const getHomeImages = () => {
    return apiServiceCall().get('/vui/frontend/home-images').then(({ data }) => data);
}

export const getHomeMotto = () => {
    return apiServiceCall().get('/vui/frontend/motto').then(({ data }) => data);
}

export const getCarouselImages = () => {
    return apiServiceCall().get('/vui/frontend/carousel').then(({ data }) => data);
}

export const getHomeMetricsData = () => {
    return apiServiceCall().get('/vui/frontend/metrics').then(({ data }) => data);
}

export const getInfoFooter = () => {
    return apiServiceCall().get('/vui/frontend/footer').then(({ data }) => data);
}
